<template>
  <svg
    width="2"
    height="65"
    viewBox="0 0 2 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 0V65"
      stroke="#8E9098"
      stroke-dasharray="2 2"
    />
  </svg>
</template>
